import React from 'react';
import { Box, IconButton } from '@mui/material';
import { PostAdd, AutoAwesomeOutlined } from '@mui/icons-material';
import TranscriptNote from '../TranscriptNote';
import { IImage, IAnalysis, INote } from '../../global/interfaces';

interface ImageBlockProps {
  editingNoteRef: React.MutableRefObject<{
    [key: string]: string | null;
  }>;
  image: IImage;
  index: number;
  noteKey: string;
  hideNotes: boolean;
  collapsed: boolean;
  styles: any;
  handleDropNote: (e: React.DragEvent<HTMLDivElement>, noteKey: string) => void;
  handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDragStart: (e: React.DragEvent<HTMLDivElement>, image: IImage) => void;
  setSelectedImage: (image: IImage) => void;
  addNote: () => void;
  addPrompt: (image: IImage) => void;
  notes: INote[] | null;
  saveNote: (title: string, description: string) => void;
  deleteNote: (e: any, idx: number) => void;
}

const ImageBlock: React.FC<ImageBlockProps> = ({
  editingNoteRef,
  image,
  index,
  noteKey,
  hideNotes,
  collapsed,
  styles,
  handleDropNote,
  handleDragOver,
  handleDragStart,
  setSelectedImage,
  addNote,
  addPrompt,
  notes,
  saveNote,
  deleteNote,
}) => {
  return (
    <Box
      draggable
      onDragStart={(e) => {
        console.log('::::onDragStart: ', e, image);
        handleDragStart(e, image);
      }}
      key={`image-${image.id || index}`}
      onDrop={(e) => handleDropNote(e, noteKey)}
      onDragOver={(e) => handleDragOver(e)}
      sx={{
        ...styles.imageWrap,
        width:
          !hideNotes && (!!image.description || !!notes)
            ? '100%'
            : 'fit-content',
      }}>
      <Box
        sx={styles.imagesContainer}
        onClick={(e) => {
          console.log('image', image);
          e.stopPropagation();
          setSelectedImage(image);
        }}
        style={{ position: 'relative' }}>
        <img
          //draggable
          //onDragStart={(e) => {
          //  console.log('::::onDragStart: ', e, image);
          //  handleDragStart(e, image);
          //}}
          key={index}
          src={image?.thumb.src}
          style={{
            ...(styles.savedScreenshot as React.CSSProperties),
            height: `${6 / (image.ratio || 1)}rem`,
          }}
        />
        <Box className="overlay-icons" sx={styles.overlayIcons}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              addNote();
            }}
            sx={styles.overlayIcon}>
            <PostAdd sx={{ color: '#fff' }} />
          </IconButton>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              addPrompt(image);
            }}
            sx={styles.overlayIcon}>
            <AutoAwesomeOutlined sx={{ color: '#fff' }} />
          </IconButton>
        </Box>
      </Box>

      {!hideNotes && (!!image.description || !!notes) && (
        <Box sx={{ flex: 1, ml: '1rem', width: '100%' }}>
          {image.description?.map((item: IAnalysis, index: number) => (
            <TranscriptNote
              key={`description-${image.id}-${index}`}
              id={index}
              note={{
                idx: index,
                title: item.query,
                description: item.response,
                src: 'a',
              }}
              editingNoteRef={editingNoteRef}
              collapsed={collapsed}
              disabled={true}
              color="#e0f7fa"
            />
          ))}

          {notes?.map(
            (note) =>
              note.src !== 'd' && (
                <TranscriptNote
                  id={index}
                  note={note}
                  editingNoteRef={editingNoteRef}
                  collapsed={collapsed}
                  saveNote={(e) => {
                    console.log('::::::::saveNote: ', e, note);
                    saveNote(note.title, note.description);
                  }}
                  deleteNote={(e) => deleteNote(e, index)}
                  color={note.src === 'a' ? '#e0f7fa' : '#f7f6d4'}
                />
              ),
          )}
        </Box>
      )}
    </Box>
  );
};

export default ImageBlock;
